export default "__VITE_ASSET__BMTpqvfr__"